export default "__VITE_ASSET__BO1X$JgO__"